import React from "react";
import { Card, CardBody, Col } from "reactstrap";
import CommonCardHeader from "../../../../Common/CommonCardHeader";
import { ColoredBreadcrumbs } from "../../../../Constant";
import { COLOURED_BREADCRUMB } from "../../../../Data/Bonus Ui/Breadcrumb";
import { StaticColoredBreadcrumb } from "./StaticColoredBreadcrumb";
import { DynamicColoredBreadcrumb } from "./DynamicColoredBreadcrumb";

const ColoredBreadcrumb = () => {
  return (
    <Col sm="12">
      <Card>
        <CommonCardHeader title={ColoredBreadcrumbs} span={COLOURED_BREADCRUMB} />
        <CardBody>
          <StaticColoredBreadcrumb />
          <DynamicColoredBreadcrumb />
        </CardBody>
      </Card>
    </Col>
  );
};

export default ColoredBreadcrumb;
